module.exports = __webpack_public_path__ + "static/media/wubing.c48a1ee8.jpg";